import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "checking") {
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-background text-ink-500"
                data-testid="auth-loading"
            >
                <div className="font-mono text-xs uppercase tracking-widest">Bezig met laden…</div>
            </div>
        );
    }

    if (status !== "authenticated") {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireRole) {
        const allowed = Array.isArray(requireRole) ? requireRole : [requireRole];
        if (!allowed.includes(user?.role)) {
            return (
                <div className="p-10" data-testid="forbidden">
                    <h1 className="text-2xl font-semibold text-ink-900">Geen toegang</h1>
                    <p className="mt-2 text-sm text-ink-500">
                        Je hebt geen rechten om deze pagina te bekijken.
                    </p>
                </div>
            );
        }
    }

    return children;
}
